import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CateringWinny from './views/staticOfertaWeselna/CateringWinny.vue'
import DoradztwoWeselne from './views/staticOfertaWeselna/DoradztwoWeselne.vue'
import OfertaWeselna from './views/OfertaWeselna.vue'
import KategorieZestawy from './components/KategorieZestawy'
import KategorieInne from './components/KategorieInne'
import Calculator from './components/Calculator'
import AlkoholNaWieczorKawalerski from './views/staticOfertaWeselna/AlkoholNaWieczorKawalerski'
import AlkoholNaWieczorPanienski from './views/staticOfertaWeselna/AlkoholNaWieczorPanienski'
import SklepDobrewino from './views/staticOfertaWeselna/SklepDobrewino'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', name: 'home', component: Home },
        { path: '/oferta-weselna', name: 'ofertaWeselna', component: OfertaWeselna },
        {
            path: '/oferta-weselna/kategorie-wina/:query?',
            name: 'kategorieWina',
            component: () =>
                import ( /* webpackChunkName: "KategorieWina" */ './components/KategorieWina')
        },
        {
            path: '/oferta-weselna/kategorie-wodki/:query?',
            name: 'kategorieWodki',
            component: () =>
                import ( /* webpackChunkName: "KategorieWodki" */ './components/KategorieWodki')
        },
        { path: '/oferta-weselna/kategorie-zestaw/:query?', name: 'kategorieZestawy', component: KategorieZestawy },
        { path: '/oferta-weselna/kategorie-inne/:query?', name: 'kategorieInne', component: KategorieInne },
        {
            path: '/oferta-weselna/kategorie-prezenty/:query?',
            name: 'kategoriePrezenty',
            component: () =>
                import ( /* webpackChunkName: "KategoriePrezenty" */ './components/KategoriePrezenty')
        },
        { path: '/oferta-weselna/catering-winny', name: 'cateringWinny', component: CateringWinny },
        { path: '/oferta-weselna/doradztwo-weselne', name: 'doradztwoWeselne', component: DoradztwoWeselne },
        { path: '/oferta-weselna/alkohol-na-wieczor-kawalerski', name: 'alkoholNaWieczorKawalerski', component: AlkoholNaWieczorKawalerski },
        { path: '/oferta-weselna/alkohol-na-wieczor-panienski', name: 'alkoholNaWieczorPanienski', component: AlkoholNaWieczorPanienski },
        { path: '/kalkulator', name: 'calculator', component: Calculator },
        { path: '/oferta-weselna/sklep-dobrewino', name: 'sklepDobrewino', component: SklepDobrewino },

        {
            path: '/item/:id',
            name: 'itemDetails',
            component: () =>
                import ( /* webpackChunkName: "ItemDetails" */ './components/ItemDetails')
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/aktualnosci',
            name: 'aktualnosci',
            component: () =>
                import ( /* webpackChunkName: "aktualnosci" */ './views/Aktualnosci.vue')
        },
        {
            path: '/debug',
            name: 'debug',
            component: () =>
                import ( /* webpackChunkName: "debug" */ './views/Debug')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})